<template>
  <main class="relative max-h-screen overflow-hidden">
    <img src="../../assets/images/login-Bg.svg" alt="" class="w-full h-screen object-cover">
    <div class="absolute mobile:w-full desktop:w-1/3 top-0 right-0">
      <div
        class="mobile:px-8 tablet:px-32 laptop:px-48 desktop:px-16 largeDesktop:px-28 h-screen flex flex-col items-center justify-center mobile:gap-3 tablet:gap-6 bg-opacity-80 bg-black-100">
        <!-- Logo -->
        <div class="flex justify-center mb-3">
          <img src="../../assets/images/fyxifyLogo.png" alt="Logo"
            class="mobile:w-20 mobile:h-20 tablet:w-40 tablet:h-40" />
        </div>

        <div>
          <h2 class="text-3xl font-roboto font-medium m-0 text-center text-white">Verification</h2>
          <p class="mobile:text-base tablet:text-lg text-center font-roboto text-white mt-4">
            Please enter the 4-digit verification code sent to <br />
            <span class="font-normal">{{ savedData ? savedData.email : '' }}</span>
          </p>
        </div>

        <!-- Code Inputs -->
        <div class="flex justify-center gap-4 mb-4">
          <input v-for="(digit, index) in code" :key="index" v-model="code[index]" ref="inputs" @input="onInput(index)"
            @keydown.backspace="onBackspace(index)" maxlength="1" type="text"
            class="w-10 h-10 text-center text-lg border rounded focus:outline-none" />
        </div>
        <button :disabled="!isCodeComplete" @click="submitCode" :class="[
          'w-max py-2 px-5 rounded-full transition ',
          isCodeComplete
            ? 'bg-gradient-to-r from-blue-600 to-sky-600 text-white'
            : 'bg-gray-200 !text-gray-500 cursor-not-allowed'
        ]">
          VERIFY
        </button>
        <div class="mt-4 text-base text-white">
          <p>
            Send the code again
            <span>{{ timer == 0 ? '' : timer + ' seconds' }}</span>
          </p>
        </div>
        <div class="flex item-center justify-center gap-3">
          <button
            class="w-max py-2 px-5 rounded-lg transition cursor-pointer border-[1px] border-white text-white hover:bg-orange-100 hover:!border-orange-100"
            @click="backClicked">
            Back
          </button>
          <button @click="resendCodeClicked" :disabled="timer > 0"
            class="w-max py-2 px-5 rounded-lg text-base disabled:cursor-not-allowed disabled:bg-[#ccc] disabled:!text-gray-500 text-white bg-[#FE5000]">Re-send</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  data() {
    return {
      code: ["", "", "", ""],
      timer: 30,
      interval: null,
      savedData: JSON.parse(localStorage.getItem('registerFormData')) ?? null
    };
  },

  computed: {
    ...mapGetters(["resendCodeResponse", "userObject"]),
    isCodeComplete() {
      return this.code.every((digit) => digit !== "");
    },
  },

  watch: {
    resendCodeResponse: function () {
      this.timer = 30;
      this.startTimer();
    },

    userObject: function () {

      if (this.userObject != 'undefined') {
        localStorage.removeItem('registerFormData')
        localStorage.setItem('user', JSON.stringify(this.userObject))
        localStorage.setItem('isSilentLogin', false)
        this.$router.push({
          path: '/protection-plan/nrg/bundle-list'
        })
      }

    },
  },

  mounted() {
    this.$refs.inputs[0].focus();
    this.startTimer();
  },
  methods: {
    ...mapActions(["resendCode", "verifyUser"]),

    onInput(index) {
      if (this.code[index].length > 1) {
        this.code[index] = this.code[index].slice(0, 1);
      }
      if (this.code[index] && index < this.code.length - 1) {
        this.$refs.inputs[index + 1].focus();
      }
    },
    onBackspace(index) {
      if (!this.code[index] && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    },
    submitCode() {
      if (this.savedData && this.savedData.email) {
        this.verifyUser({
          email: this.savedData.email,
          verification_code: this.code.join(""),
          device_type: 'web'
        })
      } else {
        toast.error("You are not allowed to perform this action.")
        this.$router.go(-1)
      }
    },
    resendCodeClicked() {
      if (this.savedData && this.savedData.email) {
        this.resendCode({
          email: this.savedData.email
        })
      } else {
        toast.error("You are not allowed to perform this action.")
        this.$router.go(-1)
      }

    },

    backClicked() {
      this.$router.go(-1)
    },
    startTimer() {
      if (this.interval) clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
  },
  unmounted() {
    if (this.interval) clearInterval(this.interval);
  },
};
</script>

<style scoped>
input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>